import { GET } from '@/server/http';
import URLS from '@/server/urls';

export default async ({
    id = 0,
}, options = { showError: true }) => {
    const [ content, error, status ] = await GET(URLS.dictionary.getDetail, { id }, options);
    if (error) return { error, status };
    return content || { id };
};
